import { isIgnoredFeature } from "@circle-react/helpers/plansHelpers";
import { Fragment } from "react";

import { t } from "@/i18n-js/instance";
import type { PlanFeatureFlags } from "@/react/types";

import { FeatureCell } from "./FeatureCell";
import { PlanFeature } from "./FeatureFlag";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface FeatureFlagsProps {
  featureFlagKeys: string[];
}

export const FeatureFlags = ({ featureFlagKeys }: FeatureFlagsProps) => {
  const { compareTablePlanFeatures } = usePlans();

  if (!compareTablePlanFeatures) return null;

  const tiers = Object.keys(compareTablePlanFeatures);

  return (
    <>
      {featureFlagKeys.map(feature => {
        if (isIgnoredFeature(feature)) return null;

        return (
          <Fragment key={feature}>
            <FeatureCell>
              <StringFeature
                hideCheckIcon
                value={t(`pricing_plans.feature.${feature}`)}
                className="pr-5"
              />
            </FeatureCell>
            {tiers.map(tier => (
              <PlanFeature
                key={tier}
                value={
                  compareTablePlanFeatures[tier][
                    feature as keyof PlanFeatureFlags
                  ] as number
                }
                feature={feature}
              />
            ))}
          </Fragment>
        );
      })}
    </>
  );
};
